import { render, staticRenderFns } from "./HomeProjectsGrid.vue?vue&type=template&id=0e4b97a0&"
import script from "./HomeProjectsGrid.vue?vue&type=script&lang=js&"
export * from "./HomeProjectsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports